module.exports = __webpack_public_path__ + "static/media/orinocco84.89643262.jpg";